export default __webpack_public_path__ + "static/media/BR - System Integrator.d824009d.png";